export const API_URL = import.meta.env.VITE_API_BASE_URL;
export const BASE_URL = import.meta.env.VITE_BASE_URL;
export const VITE_IMAGE_PATH_URL = import.meta.env.VITE_IMAGE_PATH_URL;
export const RAZORPAY_KEY_ID = import.meta.env.VITE_RAZORPAY_KEY_ID;
// NB: never expose the Razorpay secret key here. Anything read from
// `import.meta.env` is inlined into the browser bundle.
